const userDetails = []

export default userDetails